import React from "react";
import { Modal } from "antd";
import closeModal from "../../../assets/close-modal.svg"

const CustomModal = ({
  visible,
  onClose,
  style = {},
  title,
  children,
  className = "",
  headerClassName = "",
  bodyClassName = "",
  footerClassName = "",
  wrapClassName = "",
  footer = null,
  ...rest
}) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      style={style}
      footer={footer}
      centered
      className={className}
      wrapClassName={wrapClassName}
      styles={{
        content: { padding: 0 }, 
      }}
      classNames={{
        content: "!rounded-[0.625rem] w-full overflow-hidden",
        header: "!mb-0 !rounded-[0.625rem] !p-0",
        body: "!p-[1.5rem]",
      }}
      closeIcon={
        <img
          src={closeModal}
          alt="close-modal"
          onClick={onClose}
          className="w-[32px] h-[32px] bg-[#f3f4f5]"
        />
      }
      title={
        <div
          className={`
            text-[1rem] font-semibold text-[#e74860]
            rounded-t-[0.625rem]
            border-b border-white
            px-[1rem] py-[1rem]
            bg-[#f3f4f5]
            ${headerClassName}
          `}
        >
          {title}
        </div>
      }
      {...rest}
    >
      <div className={`m-0 p-0 box-border font-[Inter,sans-serif] ${bodyClassName}`}>
        {children}
      </div>
    </Modal>
  );
};

export default CustomModal;